import { postCreateOrganization } from '../api/postCreateOrganization';
import { setGetListOrganization } from './setGetListOrganization';

const setPostCreateOrganization = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateOrganization(params);
            dispatch(setGetListOrganization({
                search: ''
            }));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateOrganization
}